import dayjs from 'dayjs'
import PropTypes from 'prop-types'
import React from 'react'
import { ListItem } from '../../../../../components/generic'

export default class CarePlanHistoryRevision extends React.Component {
  state = {
    isOpen: false
  }

  render() {
    const { carer, carePlan, onClick } = this.props

    if (!carer || !carePlan) return null

    const carePlanAdl = carePlan.carePlanAdl
    const date = carePlan.editedOn || carePlan.createdOn
    const icon =
      carePlanAdl.icon && carePlanAdl.icon.url
        ? carePlanAdl.icon.url
        : carePlanAdl.icon

    return (
      <ListItem
        icon={icon}
        iconColor={carePlanAdl.color}
        label={dayjs(date).format('DD-MM-YYYY • HH:mm')}
        labelStyles={styles.date}
        onSelect={() => onClick(carePlan.id)}
        subLabel={`${carer.name.first} ${carer.name.last}`}
      />
    )
  }
}

const styles = {
  date: {
    fontWeight: 600,
    fontSize: 16
  }
}

CarePlanHistoryRevision.propTypes = {
  carer: PropTypes.object,
  carePlan: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired,
  style: PropTypes.object
}
